import React,{useEffect, useState}  from 'react'
import {Box,Typography,Container,Button,Menu,MenuItem, CircularProgress} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import MoreIcon from '@mui/icons-material/MoreVert'
import {IconButton} from "@mui/material"
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import { add_test,} from "../Redux/testSlice";
import { add_tests,} from "../Redux/testsSlice";
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ItemView from '../Components/ItemView';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import { ArrowBack, CalendarMonth, CopyAll, EditNote, Groups, Mail, Person3Outlined, Remove, Timelapse } from '@mui/icons-material';
import delete_tst from '../Redux/reducers/delete_tst';
import delete_user from '../Redux/reducers/delete_user';
import { add_report, add_reports } from '../Redux/reportsSlice'

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#100101'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
  minHeight:300,
  maxHeight:500,
  justifyContent:"center",
  alignItems:"center"
}),
);

const ItemBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
},
maxHeight:300,
minHeight:150
})
);

const CandidatePortal = ()=>{


	const theme = useTheme()
	const [level, setLevel] = useState("");
	const navigate = useNavigate()
	const [loading, setLoading] = useState(false);
	const [deleting, setDeleting] = useState(false);
	const [del, setDel] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [showModal, setShowModal] = React.useState(false);
	const [isNext, setIsNext] = React.useState(false);
	const [message, setMessage] = React.useState("");
    const [selected,setSelected] = useState(0)
    const [sending,setSending] = useState(false)
    const [loadding,setLoadding] = useState(false)
    const report = useSelector(state => state?.reports.report);
    const reports = useSelector(state => state?.reports.reports);
	const user = useSelector(state => state?.auth.user);
    const assessment = useSelector(state => state?.templates.assessment);
	const test = useSelector(state => state?.test.test);
    const assessments = useSelector(state => state?.templates.assessments);
	const tests = useSelector(state => state?.tests.tests);
	const [users, setUsers] = React.useState(test?.users || []);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [mobileAnchorEl, setMobileAnchorEl] = React.useState(null);
	const dispatch = useDispatch()

const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography color="white" ml={1} fontSize={13}> {displayText} </Typography>
  }

  async function handleWrong(id,email_data,title,question){
    try {
        
        const send_data = {
            id:id,
            email:email_data,
            title:title,
            question:question
        }

        setLoadding(true)

        const handleSend = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}handle-wrong/`,send_data,{
                headers:{
                        "Content-Type":"application/json",
                        "Authorization":`Bear ${user?.accessToken}`
                    }
            }).catch(err=>{
                setLoadding(false)
                setMessage("connection error")
                setOpen(true)
                console.log(err)
            })

            // console.log(handleSend?.data)

        if (handleSend?.status == 200 && handleSend?.data.success == true) {

            const filterReports = reports?.filter(item=>item?.email !== email_data)
            dispatch(add_reports([...filterReports,handleSend?.data?.report]))
            dispatch(add_report(handleSend?.data?.report))
            setMessage(handleSend?.data.message)
            setOpen(true)

        } else {
            setMessage(handleSend?.data.message)
            setOpen(true)
        }  
        setLoadding(false)  
    } catch (error) {
        console.log(error)
    }
}

async function handleCorrect(id,email_data,title,question){
try {

    setSending(true)
    const send_data = {
        id:id,
        email:email_data,
        title:title,
        question:question
    }

    const handleSend = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}handle-correct/`,send_data,{
            headers:{
                    "Content-Type":"application/json",
                    "Authorization":`Bear ${user?.accessToken}`
                }
        }).catch(err=>{
            console.log(err)
            setMessage("connection error")
            setOpen(true)
            setSending(false)
        })

        console.log(handleSend?.data)

    if (handleSend?.status == 200 && handleSend?.data.success) {
        
       const filterReports = reports?.filter(item=>item?.email !== email_data)
        dispatch(add_reports([...filterReports,handleSend?.data?.report]))
        dispatch(add_report(handleSend?.data?.report))
        setMessage(handleSend?.data.message)
        setOpen(true)

    } else {
        setMessage(handleSend?.data.message)
        setOpen(true)
    } 
    setSending(false)   
} catch (error) {
    console.log(error)
}
}

return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Candidate Detail</Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={()=>{
                        setOpen(false)
                    }} 
					open={open} 
					autoHideDuration={2000}
				/>
                <IconButton onClick={(e)=>{
                    e?.preventDefault()
                    navigate("/assessmentReport")
                }}>
                    <ArrowBack sx={{color:"gold"}} fontSize='small'/>
                </IconButton>
				<Box  sx={{backgroundColor:"#1a1b1b",borderRadius:2,width:"100%"}}>
					<Box m={1} display="flex" width="90%" flexDirection="row" justifyContent="space-between" alignItems="flex-start">
						<Typography mt={1}  ml={3} style={{fontSize:16,fontWeight:400,fontFamily:"dinofans"}}>
							Candidate Assessment Detail
						</Typography>
					</Box>
                    <Box width="100%" justifyContent="center" alignItems="center"  p={1} mb={1}>
                    {
                        report?.sections?.map((item,index)=>{
                            
                            var total = 0

                            item?.data.forEach(it => {
                                total += it?.point
                            });

                        return(
                            <Box key={index} width="90%" justifyContent="center" alignItems="center">
                                <Box width="100%" justifyContent="flex-start" alignItems="center" ml={2}>
                                    <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:14,color:"#ff0"}}>
                                        {index+1} section
                                    </Typography>
                                    <Box width="70%" justifyContent="space-between" alignItems="center" flexDirection="row"  display="flex" flexWrap="wrap">
                                        <Box>
                                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                                title
                                            </Typography>
                                            <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                                {item?.title}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                                Total point
                                            </Typography>
                                            <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                                {item?.total_point} points
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                                Gained point
                                            </Typography>
                                            <Typography sx={{marginBottom:1,fontSize:13,color:"#ff0"}}>
                                                {total} points
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                                Questions
                                            </Typography>
                                            <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                                {item?.total_questions}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                        Description
                                    </Typography>
                                    <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                        {item?.description}
                                    </Typography>
                            </Box>
                            <Box width="100%" justifyContent="center" alignItems="center" ml={2}>
                                    <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                        Candidate answers
                                    </Typography>
                                    <Box width="100%" justifyContent="space-between" alignItems="center" flexDirection="row"  display="flex" flexWrap="wrap">
                                        {
                                            item?.data?.map((itm,indx)=>(
                                                <Box key={indx} sx={{mb:1,background:"#000",borderRadius:2,width:"48%",height:370,justifyContent:"center",alignItems:"center"}}>
                                                    <ItemBox sx={{width:"90%",p:1,m:1}}>
                                                        <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                                            {indx+1} question
                                                        </Typography>
                                                        <Divider/>
                                                        <Typography mt={1} sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                                            question
                                                        </Typography>
                                                        <Typography sx={{marginBottom:1,fontSize:12,color:"#fff",whiteSpace:"pre-wrap"}}>
                                                            {itm?.question?.question}
                                                        </Typography>
                                                        {
                                                            itm?.question?.hasImage && (
                                                                <Box sx={{justifyContent:"center",alignItems:"center"}}>
                                                                    <img resizemode="contain" src={itm?.question?.imageUrl} width={220} height={100} style={{borderRadius:2}}/>
                                                                </Box>
                                                            )
                                                        }
                                                        {
                                                            itm?.question?.hasAudio && (
                                                                <Box sx={{justifyContent:"center",alignItems:"center"}}>
                                                                    <audio
                                                                        src={itm?.question?.audioUrl}
                                                                        controls
                                                                        style={{width:220,height:30}}
                                                                    />
                                                                </Box>
                                                            )
                                                        }
                                                        {
                                                            itm?.question?.hasVideo && (
                                                                <Box ml={2} >
                                                                    <video src={itm?.question?.videoUrl} controls style={{width:200,height:100}}/>
                                                                </Box>
                                                            )
                                                        }
                                                        <Typography mt={1} sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                                            candidate's answer
                                                        </Typography>
                                                        <Typography sx={{marginBottom:1,fontSize:12,color:"#fff",whiteSpace:"pre-wrap"}}>
                                                            {itm?.answer ? itm?.answer : "unknown"}
                                                        </Typography>
                                                        <Typography mt={1} sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                                            Possible answers
                                                        </Typography>
                                                        <ol >
                                                            {
                                                                itm?.question?.responses?.map((it,dx)=>(
                                                                    <li key={dx} style={{marginBottom:1,fontSize:11,color:"#fff",whiteSpace:"pre-wrap"}}>
                                                                        {it}
                                                                    </li>
                                                                ))
                                                            }
                                                        </ol>
                                                        <Typography mt={1} sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                                        Correct answers
                                                        </Typography>
                                                        <ol >
                                                            {
                                                                itm?.question?.correct_responses?.map((it,dx)=>(
                                                                    <li key={dx} style={{marginBottom:1,fontSize:11,color:"#fff"}}>
                                                                        {it}
                                                                    </li>
                                                                ))
                                                            }
                                                        </ol>
                                                    </ItemBox>
                                                    <Box sx={{display:"flex",flexDirection:"row",width:"90%",justifyContent:"space-between",alignItems:"center"}}>
                                                        <Box sx={{display:"flex",flexDirection:"row",width:"40%",justifyContent:"flex-start",alignItems:"center"}}>
                                                            <IconButton disabled={sending} onClick={async(e)=>{
                                                                e?.preventDefault()
                                                                setSelected(indx)
                                                                await handleCorrect(assessment?.id,report?.email,item?.title,itm?.question?.question)
                                                            }}>
                                                                {
                                                                ( sending && selected == indx) ? <CircularProgress size={15} sx={{color:"#ff0"}}/>  : <img resizemode="contain" src={require("../assets/okey.jpg")} width={25} height={25} style={{borderRadius:10}}/> 
                                                                }
                                                            </IconButton>
                                                            <IconButton disabled={sending} onClick={async(e)=>{
                                                                e?.preventDefault()
                                                                setSelected(indx)
                                                                await handleWrong(assessment?.id,report?.email,item?.title,itm?.question?.question)
                                                            }}>
                                                            {
                                                                (loadding && selected == indx) ? <CircularProgress size={15} sx={{color:"#ff0"}}/>  : <img resizemode="contain" src={require("../assets/cross.jpg")} width={25} height={25} style={{borderRadius:10}}/>
                                                            }
                                                            </IconButton>
                                                        </Box>
                                                        <Typography mt={1} sx={{marginBottom:1,fontSize:14,color:(itm?.isWrong ? "red" : itm?.isCorrect ? "green" : "#ff0")}}>
                                                            {itm?.point} points
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            ))
                                        }
                                    </Box>
                                    <Divider sx={{m:1}}/>
                            </Box>
                            </Box>
                        )}
                        )
                    }
                    </Box>
				</Box>
			</Container>
		</Box>
		)
}

export default CandidatePortal